import axios from "axios";
import {
  ElNotification,
  ElMessageBox,
  ElMessage,
  ElLoading,
} from "element-plus";
import { getToken } from "@/utils/auth";
import errorCode from "@/utils/errorCode";
import { tansParams, blobValidate } from "@/utils/ruoyi";
import useUserStore from "@/store/modules/user";

let downloadLoadingInstance;
// 是否显示重新登录
export let isRelogin = { show: false };

// Vite 通过 import.meta.env 暴露所有以 VITE_ 开头的变量
const baseURL = process.env.VUE_APP_BASE_API;
console.log("baseURL", baseURL);

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: baseURL, //"/api",
  // 超时
  timeout: 3000,
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false;
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false;
    if (getToken() && !isToken) {
      config.headers["Token"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // get请求映射params参数
    if (["get", "delete"].includes(config.method) && config.params) {
      let url = config.url + "?" + tansParams(config.params);
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    if (
      !isRepeatSubmit &&
      (config.method === "post" || config.method === "put")
    ) {
      const requestObj = {
        url: config.url,
        data:
          typeof config.data === "object"
            ? JSON.stringify(config.data)
            : config.data,
        time: new Date().getTime(),
      };
      const requestSize = Object.keys(JSON.stringify(requestObj)).length; // 请求数据大小
      const limitSize = 5 * 1024 * 1024; // 限制存放数据5M
      if (requestSize >= limitSize) {
        console.warn(
          `[${config.url}]: ` +
            "请求数据大小超出允许的5M限制，无法进行防重复提交验证。",
        );
        return config;
      }
      // const sessionObj = cache.session.getJSON("sessionObj");
      // if (
      //   sessionObj === undefined ||
      //   sessionObj === null ||
      //   sessionObj === ""
      // ) {
      //   cache.session.setJSON("sessionObj", requestObj);
      // } else {
      //   const s_url = sessionObj.url; // 请求地址
      //   const s_data = sessionObj.data; // 请求数据
      //   const s_time = sessionObj.time; // 请求时间
      //   const interval = 1000; // 间隔时间(ms)，小于此时间视为重复提交
      //   if (
      //     s_data === requestObj.data &&
      //     requestObj.time - s_time < interval &&
      //     s_url === requestObj.url
      //   ) {
      //     const message = "数据正在处理，请勿重复提交";
      //     console.warn(`[${s_url}]: ` + message);
      //     return Promise.reject(new Error(message));
      //   } else {
      //     cache.session.setJSON("sessionObj", requestObj);
      //   }
      // }
    }
    return config;
  },
  (error) => {
    console.log(error);
    Promise.reject(error);
  },
);

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.message || errorCode["default"];
    // 二进制数据则直接返回
    if (
      res.request.responseType === "blob" ||
      res.request.responseType === "arraybuffer"
    ) {
      return res;
    }
    if (code === 500) {
      ElMessage({ message: msg, type: "error" });
      return Promise.reject(new Error(msg));
    } else if (code === 601) {
      ElMessage({ message: msg, type: "warning" });
      return Promise.reject(new Error(msg));
      // } else if (code !== 200) {
      //   ElNotification.error({ title: msg });
      //   return Promise.reject("error");
    } else {
      return Promise.resolve(res.data);
    }
  },
  (error) => {
    console.log("err===============" + error);
    // 请求错误时做些事
    let status = "";
    if (error.request) {
      status = error.request;
    } else if (error.response) {
      status = error.response;
    }

    if (status) {
      if (status.status === 401) {
        if (!isRelogin.show) {
          isRelogin.show = true;
          useUserStore()
            .logOut()
            .then(() => {
              isRelogin.show = false;
              location.href = "/";
            });
        }
        return Promise.reject(status);
      }
      switch (status.status) {
        case 400:
          error.message = "请求错误(400)";
          break;
        case 403:
          error.message = "拒绝访问(403)";
          break;
        case 404:
          error.message = "请求出错(404)";
          break;
        case 408:
          error.message = "请求超时(408)";
          break;
        case 500:
          error.message = "内部服务器错误(500)";
          break;
        case 501:
          error.message = "服务未实现(501)";
          break;
        case 502:
          error.message = "网络错误(502)";
          break;
        case 503:
          error.message = "服务不可用(503)";
          break;
        case 504:
          error.message = "网络超时(504)";
          break;
        case 505:
          error.message = "HTTP版本不受支持(505)";
          break;
        default:
          if (error.message == "Network Error") {
            error.message = "后端接口连接异常";
          } else if (error.message.includes("timeout")) {
            error.message = "系统接口请求超时";
          } else if (
            error.message.includes("Request failed with status code")
          ) {
            error.message =
              "系统接口" +
              error.message.substr(error.message.length - 3) +
              "异常";
          } else {
            error.message = "连接服务器失败!";
          }
      }
    } else {
      error.message = "连接服务器失败!";
    }
    let { message } = error;

    ElMessage({ message: message, type: "error", duration: 5 * 1000 });
    return Promise.reject(error);
  },
);

/***
 * param downMethod 接口名称
 * param params 参数名
 * **/
export const zxDownload = function (downMethod, params = {}) {
  const downloadLoadingInstance = ElLoading.service({
    text: "正在下载数据，请稍候",
    background: "rgba(0, 0, 0, 0.7)",
  });
  downMethod(params).then((res) => {
    console.log("res====", res);
    if (res.data.type != "application/json") {
      // 获取文件名称
      const contentDisposition = res.headers["content-disposition"];
      let fileName = "";
      if (contentDisposition) {
        const textArr = contentDisposition.split(";") || [];
        const fileMix = textArr[1] && textArr[1].split("=");
        fileName = (fileMix[1] && decodeURIComponent(fileMix[1])) || "下载文件";
      } else {
        fileName = "未知";
      }
      let blob = res.data;
      let objectUrl = URL.createObjectURL(blob);
      const isNeedOpen = res.headers["ispreview"];
      if (isNeedOpen) {
        // 如果需要预览
        window.open(objectUrl);
      } else {
        const link = document.createElement("a"); // 创建a标签
        link.href = objectUrl;
        // const date = getDateTime(new Date().getTime());
        link.download = `${fileName}`; // 自定义文件名
        link.click(); // 下载文件
      }

      URL.revokeObjectURL(objectUrl); // 释放内存
    } else {
      ElMessage.error("文件导出失败，请联系管理员！");
    }
    downloadLoadingInstance.close();
  });
  // .catch((error) => {
  //   ElMessage.error("导出接口异常," + error);
  //   downloadLoadingInstance.close();
  // });
};

export default service;
